import {WimdStore} from '../wimdStore';
import saveAs from 'file-saver';
import {filter, map} from 'rxjs/operators';
import {Subscription} from 'rxjs';
import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {ActivatedRoute} from '@angular/router';
import {WimdModalsService} from '../wimd-modal/wimd-modals.service';
import {IconService} from '../../../../shared/services/icon/icon.service';
import {WimdModalComponent} from '../wimd-modal/wimd-modal.component';
import {ToastrService} from 'ngx-toastr';
import {ProjectWimdComponent} from '../project-wimd.component';

@Component({
  selector: 'app-wimd-table',
  templateUrl: './wimd-table.component.html',
  styleUrls: ['./wimd-table.component.css']
})
export class WimdTableComponent implements OnInit, OnDestroy {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  isLoading = true;
  passagesList: MatTableDataSource<any> = new MatTableDataSource();
  displayedColumns: string[] = [];
  filters: any = {};
  infoproget: boolean = false;
  private projectId: number;
  private wimdConfiguration: any;
  private subscriptions = new Subscription();

  constructor(
    private wimdStore: WimdStore,
    private dialog: MatDialog,
    private modalService: WimdModalsService,
    private route: ActivatedRoute,
    public iconService: IconService,
    private toastr: ToastrService,
    private projectWimdComponent: ProjectWimdComponent
  ) {
  }

  ngOnInit(): void {
    this.projectId = +this.route.snapshot.paramMap.get('idProject');
    this.subscribeWimdConfiguration();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  openMedia(mediaType: 'pdf' | 'image' | 'video', passageId: number): void {
    if (mediaType === 'pdf') {
      this.modalService.getPDF(this.projectId, passageId).subscribe({
        next: (pdf) => this.downloadPDF(pdf, passageId),
        error: (err) => this.handleError(err)
      });
    } else {
      this.dialog.open(WimdModalComponent, {
        data: {projectId: this.projectId, mediaType, passageId},
        width: '688px', height: '500px'
      });
    }
  }

  private subscribeWimdConfiguration() {
    this.subscriptions.add(
      this.projectWimdComponent.wimdConfiguration.subscribe({
        next: (conf) => {
          this.wimdConfiguration = conf;
          this.handleSubscriptionResponse(conf);
          this.subscribeWimdStoreState();
         },
        error: (err) => this.handleError(err)
      })
    );
  }

  private subscribeWimdStoreState() {
    this.subscriptions.add(
      this.wimdStore.currentState
        .pipe(
          filter(state => state && state.filters && state.chart),
          map(state => ({filters: state.filters, data: state.passages})),
          map(dataObject => this.applyFilters(dataObject))
        )
        .subscribe({
          next: (value) => this.initMatTable(value.data),
          error: (err) => this.handleError(err)
        })
    );
  }

  private handleSubscriptionResponse(conf: any): void {
    const {plate, photo, video, infoproget} = conf;
    this.infoproget = infoproget;
    this.displayedColumns = [
      'View', 'UniqueID', 'Date', 'Hour', 'Direction', 'Axles', 'Length', 'Speed', 'Weight'
    ];

    if (plate) {
      this.displayedColumns.push('Plate');
    }
    if (photo) {
      this.displayedColumns.push('Image');
    }
    if (video) {
      this.displayedColumns.push('Video');
    }
    this.displayedColumns.push('Confidence');
    this.isLoading = false;
  }

  private handleError(error: any): void {
    console.error('An error occurred:', error);
    this.isLoading = false;
    this.toastr.error('An error occurred:' + error);
  }

  private downloadPDF(pdf: Blob, passageId: number): void {
    const blob = new Blob([pdf], {type: 'application/pdf'});
    const filename = `${this.projectId}-${passageId}_WIMD.pdf`;
    saveAs(blob, filename);
  }

  private initMatTable(tableData: any[]): void {
    this.passagesList.data = tableData;
    this.passagesList.paginator = this.paginator;
    this.passagesList.sort = this.sort;
  }

  private applyFilters(dataObject: any): any {
    dataObject.data = dataObject.data.reduce(
      (passagesArray: any[], passage: any) => {
        if (this.minValueValidator(dataObject.filters.thresholds[0], passage)
        ) {
          const formattedPassage = this.thresholdZoneSetter(dataObject.filters.thresholds, passage);
          passagesArray.push(formattedPassage);
        }
        return passagesArray;
      },
      []);
    return dataObject;
  }

  private minValueValidator(minThreshold, passage): any {
    return (minThreshold && minThreshold !== '') ? minThreshold <= passage.Weight : true;
  }

  private thresholdZoneSetter(thresholds: number[], passage: any): any {
    if (thresholds.length > 0) {
      passage.userThreshold = 'threshold1';
      if (passage.Weight >= thresholds[1]) {
        passage.userThreshold = 'threshold2';
      }
      if (passage.Weight >= thresholds[2]) {
        passage.userThreshold = 'threshold3';
      }
    } else {
      passage.userThreshold = undefined;
    }
    return passage;
  }
}
